/**
 * Bank Imports Routes
 *
 * These routes are children of bank-accounts/:id and inherit the :id param
 */

export default [
    {
        path: 'bank-imports',
        component: () =>
            import('@/pages/[organisation]/banking/bank-imports.vue'),
        name: 'banking.bank-imports.search-bank-imports',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-import.view-bank-imports',
        },
    },
    {
        path: 'import-transactions',
        component: () =>
            import('@/pages/[organisation]/banking/import-transactions.vue'),
        name: 'banking.bank-imports.import-transactions',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-import.import-bank-transaction',
        },
    },
    {
        path: 'bank-imports/:importId',
        component: () =>
            import('@/pages/[organisation]/banking/bank-imports/[importId].vue'),
        name: 'banking.bank-imports.view-bank-import',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-import.view-bank-imports',
        },
    },
    {
        path: 'bank-imports/:batchId/batch',
        component: () =>
            import('@/pages/[organisation]/banking/bank-imports/[batchId]/batch.vue'),
        name: 'banking.bank-imports.search-bank-import-batch',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-import.view-bank-imports',
        },
    },
    {
        path: 'bank-imports/:batchId/batch/:importId',
        component: () =>
            import('@/pages/[organisation]/banking/bank-imports/[batchId]/batch/[importId].vue'),
        name: 'banking.bank-imports.view-batched-bank-import',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-import.view-bank-imports',
        },
    },
];
